import { cn } from "@/lib/utils";
import { fmtTime } from "@/lib/format";
import { agendaKey, agendaStyle, isDone } from "@/lib/agendaColors";

const DAY_MS = 86400000;
const WEEKDAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

export const MonthGrid = ({ from, month, items, onOpen, onCreate, drag }) => {
  const days = Array.from({ length: 42 }, (_, i) => new Date(from.getTime() + i * DAY_MS));
  const today = new Date().toDateString();
  return (
    <div className="overflow-x-auto" data-testid="calendar-month-grid">
      <div className="min-w-[640px]">
        <div className="grid grid-cols-7 border-b border-line">
          {WEEKDAYS.map((w) => <div key={w} className="px-2 py-2 text-xs font-semibold text-slate-500">{w}</div>)}
        </div>
        <div className="grid grid-cols-7">
          {days.map((d) => {
            const list = items.filter((e) => new Date(e.start_at).toDateString() === d.toDateString());
            const isToday = d.toDateString() === today;
            return (
              <div key={d.toISOString()} onClick={() => onCreate && onCreate(new Date(d.getTime() + 9 * 3600000))}
                onDragOver={(ev) => drag?.active() && ev.preventDefault()}
                onDrop={(ev) => { ev.preventDefault(); const s = new Date(drag.item().start_at); drag.drop(new Date(d.getFullYear(), d.getMonth(), d.getDate(), s.getHours(), s.getMinutes())); }}
                className={cn("min-h-[104px] border-b border-r border-line p-1.5 transition-colors hover:bg-slate-50",
                  d.getMonth() !== month && "bg-slate-50/60")} data-testid={`month-day-${d.getDate()}-${d.getMonth()}`}>
                <span className={cn("inline-flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold",
                  isToday ? "bg-brand-600 text-white" : d.getMonth() === month ? "text-ink" : "text-slate-400")}>{d.getDate()}</span>
                <div className="mt-1 space-y-0.5">
                  {list.slice(0, 3).map((e) => (
                    <button key={e.id} onClick={(ev) => { ev.stopPropagation(); onOpen(e); }} data-testid={`month-event-${e.id}`} data-kind={agendaKey(e)}
                      draggable={!!drag && drag.can(e)} onDragStart={(ev) => { drag.start(e, 0); ev.dataTransfer.effectAllowed = "move"; }} onDragEnd={() => drag.end()}
                      className={cn("flex w-full items-center gap-1 truncate rounded px-1 py-0.5 text-left text-[11px] hover:bg-brand-50", drag?.can(e) && "cursor-grab")}>
                      <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", agendaStyle(e).dot)} />
                      <span className="font-mono text-slate-500">{e.is_all_day ? "" : fmtTime(e.start_at)}</span>
                      <span className={cn("truncate text-ink", isDone(e) && "text-slate-400 line-through")}>{e.subject}</span>
                    </button>
                  ))}
                  {list.length > 3 && <p className="px-1 text-[11px] font-medium text-slate-500">+{list.length - 3} altri</p>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
